import { computed, reactive, toRaw } from "vue";

const modalStack = reactive({
    stack: [],
    push (modal) {
        for (const modal of this.stack) {
            if (modal.modalState) {
                modal.modalState.isTopModal = false;
            }
        }
        this.stack.push(modal);
        if (modal.modalState) {
            modal.modalState.isTopModal = true;
        }
    },
    remove (modal) {
        modal = toRaw(modal);
        this.stack = this.stack.filter(item => {
            const keep = toRaw(item) !== modal;
            if (! keep && item.modalState) {
                item.modalState.isTopModal = false;
            }
            return keep;
        });
        
        if (this.stack.length > 0) {
            const top = this.stack[this.stack.length - 1];
            if (top.modalState) {
                top.modalState.isTopModal = true;
            }
        }
    },
    top: computed(() => {
        if (modalStack.stack.length === 0) return null;
        const top = modalStack.stack[modalStack.stack.length - 1];
        return top;
    }),
});


// Press escape to close any modal
window.document.body.addEventListener('keydown', ev => {
    const top = modalStack.top;
    if (!top) return;

    if (ev.key === 'Escape') {
        top.close();
    }

    // top.body = modal.js component
    // top.$refs?.overlay = modal.vue component
    // top.$el = regular vue component with a single root element
    let focusableElementsParent = top.body || top.$refs?.overlay || top.$el;

    if (focusableElementsParent && ev.key === 'Tab') {
        // Get all focusable elements in the modal
        const focusableElements = Array.from(focusableElementsParent.querySelectorAll(
            'button, [href], input:not([disabled]), select, textarea'
        )).filter(el => el.offsetParent !== null); // Filter out hidden elements
        
        if (focusableElements.length === 0) return;
        
        // Get first and last focusable elements
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        
        // Handle Tab and Shift+Tab to cycle within the modal
        if (ev.shiftKey) { // Shift+Tab
            if (document.activeElement === firstElement) {
                lastElement.focus();
                ev.preventDefault();
            }
        } else { // Tab
            if (document.activeElement === lastElement) {
                firstElement.focus();
                ev.preventDefault();
            }
        }
        
        // If focus is outside the modal completely, move it to first element
        if (!focusableElementsParent.contains(document.activeElement)) {
            firstElement.focus();
            ev.preventDefault();
        }
    }
});



setTimeout(() => {
    window._gmf_debug.modalStack = modalStack;
}, 0);

export default modalStack;